import { render, staticRenderFns } from "./doctorSalaryRule.vue?vue&type=template&id=a810b394&scoped=true"
import script from "./doctorSalaryRule.vue?vue&type=script&lang=js"
export * from "./doctorSalaryRule.vue?vue&type=script&lang=js"
import style0 from "./doctorSalaryRule.vue?vue&type=style&index=0&id=a810b394&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a810b394",
  null
  
)

export default component.exports